import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../api";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const sellMyCarApi = createApi({
  reducerPath: "sellMyCarApi", // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getVehicleInfo: builder.query({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "GET",
      })
    }),
    submitCarForm: builder.query({
      query: ({ formData, endpoint }) => ({
        url: endpoint,
        method: "POST",
        body: formData,
      }),
    }),
    relistCar: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/seller/relistingeditfunctionality/${Vehicle_Id}/Relist`,
          method: "GET"
        }
      }
    })
  }),
});

export const { 
  useSubmitCarFormQuery,
  useGetVehicleInfoQuery
} = sellMyCarApi;

export const {
  useLazyGetVehicleInfoQuery,
  useLazySubmitCarFormQuery,
  useLazyRelistCarQuery
} = sellMyCarApi;

